"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vee_validate_1 = require("vee-validate");
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var apply_service_const_1 = __importDefault(require("../../../common/src/constrains/contract_form/apply_service_const"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var price_utils_1 = __importDefault(require("../../../common/src/utils/validation/price_utils"));
var price_book_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/price_book_utils"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var TokubetuDetailLink_1 = __importDefault(require("./TokubetuDetailLink"));
var ApplyInfo = /** @class */ (function (_super) {
    __extends(ApplyInfo, _super);
    function ApplyInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            applyDate: date_parser_1.default.toString(new Date()),
            applyService: [0],
            kinoKunrenPeriod: '',
            applyCapacity: '',
            oralCarePeriod: '',
            kinoKunrenStartDate: '',
            oralCareSstartDate: '',
            inputNumber: '',
            oralCarePriceBook2Description: '',
            kobetuPriceBook2Description: '',
            kobetuPriceBook2Id: '',
            oralCarePriceBook2Id: '',
            inputPrice: '',
            kobetuPrice: '',
            oralCcarePrice: '',
            oralCareFreePeriod: '',
            kobetuFreePeriod: '',
            oralCareTokubetuDetail: '',
            kobetuTokubetuDetail: '',
            kobetuPriceBookData: [],
            oralCarePriceBookData: [],
            oralCareProductPlanName: '',
            kobetuProductPlanName: '',
            oralCarePriceBookUrl: '',
            kobetuPriceBookUrl: '',
            kobetuPriceBookMonth: '',
            oralCarePriceBookMonth: '',
            previousPlan: '',
            contractPlan: '',
            currentContractEndDate: '',
            toUpgradeCapacity: '',
            toUpradePlanPeriodStr: '',
            toUpgradePrice: '',
            toUpgradePeriod: '',
            toUpgradeStartDate: '',
            toUpgradeSelectedItem: '',
            toUpgradeData: [],
            basicKunrenPeriod: '',
            basicStartDate: '',
            basicPriceBook2Description: '',
            basicPriceBook2Id: '',
            basicPrice: '',
            basicFreePeriod: '',
            basicTokubetuDetail: '',
            basicPriceBookData: [],
            basicProductPlanName: '',
            basicPriceBookUrl: '',
            basicPriceBookMonth: '',
            applyCapacityBasic: '',
            entryKunrenPeriod: '',
            entryStartDate: '',
            entryPriceBook2Description: '',
            entryPriceBook2Id: '',
            entryPrice: '',
            entryFreePeriod: '',
            entryTokubetuDetail: '',
            entryPriceBookData: [],
            entryProductPlanName: '',
            entryPriceBookUrl: '',
            entryPriceBookMonth: '',
            mediumKunrenPeriod: '',
            mediumStartDate: '',
            mediumPriceBook2Description: '',
            mediumPriceBook2Id: '',
            mediumPrice: '',
            mediumFreePeriod: '',
            mediumTokubetuDetail: '',
            mediumPriceBookData: [],
            mediumProductPlanName: '',
            mediumPriceBookUrl: '',
            mediumPriceBookMonth: '',
            applyCapacityMedium: '',
            standardKunrenPeriod: '',
            standardStartDate: '',
            standardPriceBook2Description: '',
            standardPriceBook2Id: '',
            standardPrice: '',
            standardFreePeriod: '',
            standardTokubetuDetail: '',
            standardPriceBookData: [],
            standardProductPlanName: '',
            standardPriceBookUrl: '',
            standardPriceBookMonth: '',
            standardProductId: '',
            applyCapacityStandard: '',
            professionalKunrenPeriod: '',
            professionalStartDate: '',
            professionalPriceBook2Description: '',
            professionalPriceBook2Id: '',
            professionalPrice: '',
            professionalFreePeriod: '',
            professionalTokubetuDetail: '',
            professionalPriceBookData: [],
            professionalProductPlanName: '',
            professionalPriceBookUrl: '',
            professionalPriceBookMonth: '',
            professionalProductId: '',
            applyCapacityProfessional: '',
            upgradeToStandardPriceBook2Id: '',
            upgradeToStandardBaseContractEndDate: '',
            upgradeToStandardData: [],
            upgradeToStandardFamilyName: [],
            upgradeToStandardTokubetuDetail: '',
            upgradeToStandardPriceBookData: [],
            additionalTablets: '',
            additionalTabletStartDate: '',
            additionalTabletTokubetuDetail: '',
            displayDataTableObj: [],
            motionAiKunrenPeriod: '',
            motionAiStartDate: '',
            motionAiPriceBook2Description: '',
            motionAiPriceBook2Id: '',
            motionAiPrice: '',
            motionAiFreePeriod: '',
            motionAiTokubetuDetail: '',
            motionAiPriceBookData: [],
            motionAiProductPlanName: '',
            motionAiPriceBookUrl: '',
            motionAiPriceBookMonth: '',
            motionAiProductId: '',
            applyCapacityMotionAi: '',
            oldStandardKunrenPeriod: '',
            oldStandardStartDate: '',
            oldStandardPriceBook2Description: '',
            oldStandardPriceBook2Id: '',
            oldStandardPrice: '',
            oldStandardFreePeriod: '',
            oldStandardTokubetuDetail: '',
            oldStandardPriceBookData: [],
            oldStandardProductPlanName: '',
            oldStandardPriceBookUrl: '',
            oldStandardPriceBookMonth: '',
            applyCapacityOldStandard: ''
        };
        _this.kinoKunren = 'true';
        _this.oralCare = 'true';
        _this.basic = 'true';
        _this.entry = 'true';
        _this.medium = 'true';
        _this.standard = 'true';
        _this.professional = 'true';
        _this.upgradeToStandard = 'true';
        _this.additionalTablet = 'true';
        _this.motionAi = 'true';
        _this.oldStandard = 'true';
        _this.toUpgrade = 'true';
        _this.showKobetsuTab = false;
        _this.showOralCareTab = false;
        _this.showBasicTab = true;
        _this.showEntryTab = true;
        _this.showMediumTab = true;
        _this.showStandardTab = true;
        _this.showProfessionalTab = true;
        _this.showUpgradeToStandardTab = true;
        _this.showAdditionalTableTab = true;
        _this.showMotionAiTab = true;
        _this.showOldStandardTab = true;
        _this.showtoUpgradeTab = true;
        _this.upgradeToStandardPlanName = '';
        return _this;
    }
    ApplyInfo.prototype.data = function () {
        return {
            tabletHeaders: [
                {
                    text: '商品名',
                    value: 'productName'
                },
                {
                    text: '単価',
                    value: 'unitPrice'
                },
                { text: '台数',
                    value: 'tabletNumbers'
                },
                { text: '合計',
                    value: 'total'
                }
            ],
            tabletItems: [
                {
                    productName: '',
                    unitPrice: 0,
                    tabletNumbers: 0,
                    total: 0
                }
            ]
        };
    };
    // standard price book利用の際はradioを表示
    ApplyInfo.prototype.showCapacityRadio = function () {
        return price_book_utils_1.default.isStandardPriceBook(this.form.kobetuPriceBook2Id);
    };
    ApplyInfo.prototype.getPriceStr = function (price) {
        return price_utils_1.default.getPriceStr(price);
    };
    ApplyInfo.prototype.isKobetuPlanSelectable = function () {
        return price_book_utils_1.default.isSelectableProduct(this.form.kobetuPriceBook2Id);
    };
    ApplyInfo.prototype.isShowKobetuBikoLink = function () {
        return value_checker_1.default.isPresent(this.form.kobetuPriceBookUrl);
    };
    ApplyInfo.prototype.isShowBasicBikoLink = function () {
        return value_checker_1.default.isPresent(this.form.basicPriceBookUrl);
    };
    ApplyInfo.prototype.isShowStandardBikoLink = function () {
        return value_checker_1.default.isPresent(this.form.standardPriceBookUrl);
    };
    ApplyInfo.prototype.isShowOralCareBikoLink = function () {
        return value_checker_1.default.isPresent(this.form.oralCarePriceBookUrl);
    };
    ApplyInfo.prototype.isOralCarePlanSelectable = function () {
        return price_book_utils_1.default.isSelectableProduct(this.form.oralCarePriceBook2Id);
    };
    ApplyInfo.prototype.getKobetuPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.kobetuProductPlanName, this.form.kobetuPriceBook2Description);
    };
    ApplyInfo.prototype.getOralCarePlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.oralCareProductPlanName, this.form.oralCarePriceBook2Description);
    };
    ApplyInfo.prototype.getBasicPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.basicProductPlanName, this.form.basicPriceBook2Description);
    };
    ApplyInfo.prototype.getEntryPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.entryProductPlanName, this.form.entryPriceBook2Description);
    };
    ApplyInfo.prototype.getOldStandardPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.oldStandardProductPlanName, this.form.oldStandardPriceBook2Description);
    };
    ApplyInfo.prototype.getMediumPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.mediumProductPlanName, this.form.mediumPriceBook2Description);
    };
    ApplyInfo.prototype.getStandardPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.standardProductPlanName, this.form.standardPriceBook2Description);
    };
    ApplyInfo.prototype.getProfessionalPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.professionalProductPlanName, this.form.professionalPriceBook2Description);
    };
    ApplyInfo.prototype.getMotionAiPlanName = function () {
        return object_utils_1.default.getApplyPlanText(this.form.motionAiProductPlanName, this.form.motionAiPriceBook2Description);
    };
    ApplyInfo.prototype.getKobetuPrice = function () {
        if (!this.isShowKobetuPrice()) {
            return '';
        }
        if (price_book_utils_1.default.isNotStandardPriceBook(this.form.kobetuPriceBook2Id)) {
            return this.getPriceStr(this.form.kobetuPrice);
        }
        var priceBookData = price_book_utils_1.default.getKobetuProductData(this.form.kobetuPriceBookData, this.form.applyCapacity, object_utils_1.default.getSalesForcePeriod(this.form.kinoKunrenPeriod));
        return this.getPriceStr(String(priceBookData['price']));
    };
    ApplyInfo.prototype.getOralCarePrice = function () {
        if (!this.isShowOralCarePrice()) {
            return '';
        }
        if (price_book_utils_1.default.isNotStandardPriceBook(this.form.oralCarePriceBook2Id)) {
            return this.getPriceStr(this.form.oralCcarePrice);
        }
        var priceBookData = price_book_utils_1.default.getOralCareProductData(this.form.oralCarePriceBookData, object_utils_1.default.getSalesForcePeriod(this.form.oralCarePeriod));
        return this.getPriceStr(String(priceBookData['price']));
    };
    ApplyInfo.prototype.getBasicPrice = function () {
        return this.getPriceStr(this.form.basicPrice);
    };
    ApplyInfo.prototype.getEntryPrice = function () {
        return this.getPriceStr(this.form.entryPrice);
    };
    ApplyInfo.prototype.getMediumPrice = function () {
        return this.getPriceStr(this.form.mediumPrice);
    };
    ApplyInfo.prototype.getStandardPrice = function () {
        return this.getPriceStr(this.form.standardPrice);
    };
    ApplyInfo.prototype.getProfessionalPrice = function () {
        return this.getPriceStr(this.form.professionalPrice);
    };
    ApplyInfo.prototype.getMotionAiPrice = function () {
        return this.getPriceStr(this.form.motionAiPrice);
    };
    ApplyInfo.prototype.getOldStandardPrice = function () {
        return this.getPriceStr(this.form.oldStandardPrice);
    };
    ApplyInfo.prototype.getUpgradePrice = function () {
        return this.getPriceStr(this.form.toUpgradePrice);
    };
    ApplyInfo.prototype.setData = function (data) {
        var self_ = this;
        Object.keys(this.form).forEach(function (key) {
            self_.form[key] = data[key];
        });
        if (!this.form.applyService.includes(apply_service_const_1.default.KOBETSU)) {
            this.kinoKunren = '';
            // this.showKobetsuTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.ORAL_CARE)) {
            this.oralCare = '';
            // this.showOralCareTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.ENTRY)) {
            this.entry = '';
            this.showEntryTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.BASIC)) {
            this.basic = '';
            this.showBasicTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.OLD_STANDARD)) {
            this.oldStandard = '';
            this.showOldStandardTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.MEDIUM)) {
            this.medium = '';
            this.showMediumTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.PROFESSIONAL)) {
            this.professional = '';
            this.showProfessionalTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.STANDARD)) {
            this.standard = '';
            this.showStandardTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.MOTION_AI)) {
            this.motionAi = '';
            this.showMotionAiTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD)) {
            this.upgradeToStandard = '';
            this.showUpgradeToStandardTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.ADDITIONAL_TABLET)) {
            this.additionalTablet = '';
            this.showAdditionalTableTab = false;
        }
        if (!this.form.applyService.includes(apply_service_const_1.default.UPGRADE)) {
            this.toUpgrade = '';
            this.showtoUpgradeTab = false;
        }
        if (value_checker_1.default.isBlank(this.form.applyDate)) {
            this.form.applyDate = date_parser_1.default.toString(new Date());
        }
        if (this.form.applyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD)) {
            if (this.form.upgradeToStandardData.length !== 0) {
                // アップグレード対象のプラン
                this.upgradeToStandardPlanName = this.form.upgradeToStandardData[0].familyName;
            }
        }
    };
    ApplyInfo.prototype.isShowKobetuPrice = function () {
        return value_checker_1.default.isPresent(this.form.kobetuPriceBook2Id);
    };
    ApplyInfo.prototype.isShowBasicPrice = function () {
        return value_checker_1.default.isPresent(this.form.basicPriceBook2Id);
    };
    ApplyInfo.prototype.isShowStandardPrice = function () {
        return value_checker_1.default.isPresent(this.form.standardPriceBook2Id);
    };
    ApplyInfo.prototype.isShowProfessionalPrice = function () {
        return value_checker_1.default.isPresent(this.form.professionalPriceBook2Id);
    };
    ApplyInfo.prototype.isShowKobetuTokubetuDetail = function () {
        return this.isShowKobetuBikoLink() ||
            value_checker_1.default.isPresent(this.form.kobetuTokubetuDetail);
    };
    ApplyInfo.prototype.isShowOralCareTokubetuDetail = function () {
        return this.isShowOralCareBikoLink() ||
            value_checker_1.default.isPresent(this.form.oralCareTokubetuDetail);
    };
    ApplyInfo.prototype.isShowOralCarePrice = function () {
        return value_checker_1.default.isPresent(this.form.oralCarePriceBook2Id);
    };
    ApplyInfo.prototype.isShowToUpgradeLimitedPreviousPlanName = function () {
        return object_utils_1.default.limitedPlanTexts("apply_info_previous_plan", this.form.toUpgradeData, this.form.toUpgradeSelectedItem, this.form.previousPlan, '', this.form.toUpgradeStartDate);
    };
    ApplyInfo.prototype.isShowToUpgradeLimitedAfterPlanName = function () {
        return object_utils_1.default.limitedPlanTexts("apply_info_after_plan", this.form.toUpgradeData, this.form.toUpgradeSelectedItem, this.form.previousPlan, this.form.contractPlan, this.form.toUpgradeStartDate);
    };
    ApplyInfo.prototype.getApplyDate = function () {
        return date_parser_1.default.toJapaneseDateStr(this.form.applyDate);
    };
    ApplyInfo.prototype.getApplyServiceRule = function () {
        if (!this.form.applyService.includes(apply_service_const_1.default.KOBETSU) &&
            !this.form.applyService.includes(apply_service_const_1.default.ORAL_CARE) &&
            !this.form.applyService.includes(apply_service_const_1.default.UPGRADE) &&
            !this.form.applyService.includes(apply_service_const_1.default.BASIC) &&
            !this.form.applyService.includes(apply_service_const_1.default.ENTRY) &&
            !this.form.applyService.includes(apply_service_const_1.default.STANDARD) &&
            !this.form.applyService.includes(apply_service_const_1.default.PROFESSIONAL) &&
            !this.form.applyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD) &&
            !this.form.applyService.includes(apply_service_const_1.default.ADDITIONAL_TABLET) &&
            !this.form.applyService.includes(apply_service_const_1.default.MOTION_AI) &&
            !this.form.applyService.includes(apply_service_const_1.default.OLD_STANDARD)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getKinoKunrenRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.KOBETSU)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getOralCareRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.ORAL_CARE)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getToUpgradeRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.UPGRADE)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getBasicRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.BASIC)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getEntryRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.ENTRY)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getMediumRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.MEDIUM)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getStandardRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.STANDARD)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getProfessionalRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.PROFESSIONAL)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getMotionAiRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.MOTION_AI)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getUpgradeToStandardRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.getAdditionalTabletRule = function () {
        if (this.form.applyService.includes(apply_service_const_1.default.ADDITIONAL_TABLET)) {
            return 'required';
        }
        return '';
    };
    ApplyInfo.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var hasError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.refs().inputObserver.validate()];
                    case 1:
                        hasError = !(_a.sent());
                        if (hasError) {
                            this.$emit('error-occured');
                            return [2 /*return*/];
                        }
                        this.$emit('error-fixed');
                        this.$emit('submit-complete', { component: 'applyInfo', data: this.form });
                        return [2 /*return*/];
                }
            });
        });
    };
    ApplyInfo.prototype.refs = function () {
        return this.$refs;
    };
    ApplyInfo.prototype.back = function (event) {
        event.preventDefault();
        this.$emit('on-back', { component: 'applyInfo', data: this.form });
    };
    ApplyInfo.prototype.onKinoKunrenChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.KOBETSU);
        // 値をクリア
        if (!newVal) {
            this.form.kinoKunrenPeriod = '';
            this.form.kinoKunrenStartDate = '';
        }
    };
    ApplyInfo.prototype.onOralCareChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.ORAL_CARE);
        // 値をクリア
        if (!newVal) {
            this.form.oralCarePeriod = '';
            this.form.oralCareSstartDate = '';
        }
    };
    ApplyInfo.prototype.onBasicChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.BASIC);
        // 値をクリア
        if (!newVal) {
            this.form.basicPeriod = '';
            this.form.basicStartDate = '';
        }
    };
    ApplyInfo.prototype.onEntryChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.ENTRY);
        // 値をクリア
        if (!newVal) {
            this.form.entryPeriod = '';
            this.form.entryStartDate = '';
        }
    };
    ApplyInfo.prototype.onMediumChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.MEDIUM);
        // 値をクリア
        if (!newVal) {
            this.form.mediumPeriod = '';
            this.form.mediumStartDate = '';
        }
    };
    ApplyInfo.prototype.onStandardChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.STANDARD);
        // 値をクリア
        if (this.form.applyService.includes(apply_service_const_1.default.STANDARD)) {
            if (newVal) {
                this.form.standardPeriod = '';
                this.form.standardStartDate = '';
            }
        }
    };
    ApplyInfo.prototype.onProfessionalChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.PROFESSIONAL);
        // 値をクリア
        if (newVal) {
            this.form.professionalPeriod = '';
            this.form.professionalStartDate = '';
        }
    };
    ApplyInfo.prototype.onMotionAiChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.MOTION_AI);
        // 値をクリア
        if (!newVal) {
            this.form.motionAiPeriod = '';
            this.form.motionAiStartDate = '';
        }
    };
    ApplyInfo.prototype.onOldStandardChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.OLD_STANDARD);
        // 値をクリア
        if (!newVal) {
            this.form.oldStandardPeriod = '';
            this.form.oldStandardStartDate = '';
        }
    };
    ApplyInfo.prototype.onUpgradeToStandardChanged = function (newVal) {
        this.serviceVisibleChange(newVal, apply_service_const_1.default.UPGRADE_TO_STANDARD);
        // 値をクリア
        if (this.form.applyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD)) {
            if (newVal) {
                this.form.standardPeriod = '';
                this.form.standardStartDate = '';
                this.form.standardProductPlanName = '';
                this.form.standardPrice = '';
                this.form.standardPriceBookMonth = '';
                this.form.standardProductId = '';
            }
        }
    };
    ApplyInfo.prototype.alterPlanDate = function (newVal) {
        if (this.form.applyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD)) {
            var diffMonth_1 = object_utils_1.default.compareBwetweeYearMonth(this.form.upgradeToStandardBaseContractEndDate, newVal, "YearMonth");
            // 当月も含めるため＋１ヶ月とする
            diffMonth_1 = diffMonth_1 + 1;
            // 選択された日付にもとづく商品
            var defaultProductItem = this.form.upgradeToStandardPriceBookData.filter(function (value) {
                return value.family === "Rehab Cloud アップグレード" && value.monthCount === diffMonth_1.toString();
            });
            this.form.standardProductPlanName = defaultProductItem[0].period;
            this.form.standardPrice = defaultProductItem[0].price;
            this.form.standardPriceBookMonth = defaultProductItem[0].monthCount;
            this.form.standardProductId = defaultProductItem[0].value;
        }
    };
    ApplyInfo.prototype.getBikoHtml = function (bikoStr) {
        return object_utils_1.default.getBikoHtml(bikoStr);
    };
    ApplyInfo.prototype.serviceVisibleChange = function (newVal, serviceVal) {
        if (newVal) {
            if (this.form.applyService.includes(serviceVal)) {
                return;
            }
            this.form.applyService.push(serviceVal);
            return;
        }
        var kinoKunrenIndex = this.form.applyService.indexOf(serviceVal);
        if (kinoKunrenIndex !== -1) {
            this.form.applyService.splice(kinoKunrenIndex, 1);
        }
    };
    ApplyInfo.prototype.isShowKobetuPlanPeriod = function () {
        return value_checker_1.default.isPresent(this.form.kobetuPriceBookMonth);
    };
    ApplyInfo.prototype.getKobetuPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.kinoKunrenStartDate, this.form.kobetuFreePeriod, this.form.kobetuPriceBookMonth);
    };
    ApplyInfo.prototype.getBasicPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.basicStartDate, '', this.form.basicPriceBookMonth, this.form.basicProductPlanName);
    };
    ApplyInfo.prototype.getEntryPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.entryStartDate, '', this.form.entryPriceBookMonth, this.form.entryProductPlanName);
    };
    ApplyInfo.prototype.getMediumPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.mediumStartDate, '', this.form.mediumPriceBookMonth, this.form.mediumProductPlanName);
    };
    ApplyInfo.prototype.getStandardPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.standardStartDate, '', this.form.standardPriceBookMonth, this.form.standardProductPlanName);
    };
    ApplyInfo.prototype.getProfessionalPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.professionalStartDate, '', this.form.professionalPriceBookMonth, this.form.professionalProductPlanName);
    };
    ApplyInfo.prototype.getMotionAiPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.motionAiStartDate, '', this.form.motionAiPriceBookMonth, this.form.motionAiProductPlanName);
    };
    ApplyInfo.prototype.getOldStandardPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.oldStandardStartDate, '', this.form.oldStandardPriceBookMonth, this.form.oldStandardProductPlanName);
    };
    ApplyInfo.prototype.getAdditionalTabletPlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.additionalTabletStartDate, '', '1', 'tablet');
    };
    ApplyInfo.prototype.isShowOralCarePlanPeriod = function () {
        return value_checker_1.default.isPresent(this.form.oralCarePriceBookMonth);
    };
    ApplyInfo.prototype.getOralCarePlanPeriod = function () {
        return object_utils_1.default.getPlanPeriodStr(this.form.oralCareSstartDate, this.form.oralCareFreePeriod, this.form.oralCarePriceBookMonth);
    };
    Object.defineProperty(ApplyInfo, "SERVICES", {
        get: function () {
            return {
                KINO_KUNREN: 0,
                ORAL_CARE: 1,
                BASIC: 2,
                STANDARD: 3,
                UPGRADE_TO_STANDARD: 4,
                ADDITIONAL_TABLET: 5,
                MOTION_AI: 6,
                OLD_STANDARD: 7,
                ENTRY: 8,
                MEDIUM: 9,
                PROFESSIONAL: 10
            };
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], ApplyInfo.prototype, "getMessage", void 0);
    __decorate([
        vue_property_decorator_1.Watch('kinoKunren')
    ], ApplyInfo.prototype, "onKinoKunrenChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('oralCare')
    ], ApplyInfo.prototype, "onOralCareChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('basic')
    ], ApplyInfo.prototype, "onBasicChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('entry')
    ], ApplyInfo.prototype, "onEntryChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('medium')
    ], ApplyInfo.prototype, "onMediumChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('standard')
    ], ApplyInfo.prototype, "onStandardChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('professional')
    ], ApplyInfo.prototype, "onProfessionalChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('motionAi')
    ], ApplyInfo.prototype, "onMotionAiChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('oldStandard')
    ], ApplyInfo.prototype, "onOldStandardChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('upgradeToStandard')
    ], ApplyInfo.prototype, "onUpgradeToStandardChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('form.standardStartDate')
    ], ApplyInfo.prototype, "alterPlanDate", null);
    ApplyInfo = __decorate([
        vue_property_decorator_1.Component({
            components: {
                TokubetuDetailLink: TokubetuDetailLink_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                ValidationProvider: vee_validate_1.ValidationProvider,
                ValidationObserver: vee_validate_1.ValidationObserver
            }
        })
    ], ApplyInfo);
    return ApplyInfo;
}(vue_property_decorator_1.Vue));
exports.default = ApplyInfo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contract_form/ApplyInfo.vue
// module id = RuOH
// module chunks = 1